import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { getTokenLocalStorage } from '@core/services';
import { PathsEnum } from '@routes/enumerators/paths.enum';

interface IProtectedRouteProps {
    element: any;
}

export const ProtectedRoute: React.FC<IProtectedRouteProps> = ({ element }) => {
    const isAuthenticated = !!getTokenLocalStorage();
    const location = useLocation();

    if (isAuthenticated) {
        return element;
    }
    return Navigate({ to: PathsEnum.LOGIN, state: { previousUrl: location.pathname } });
};
